// Сторонние виджеты, расширения браузера, отменённые запросы axios
const IGNORED_ERROR_PATTERNS = [
  /roistat/i,
  /myreviews/i,
  /getreview/i,
  /VerticalWidget/i,
  /Request aborted/i,
  // Виджет открытых линий Битрикс24 (upload/crm/site_button/loader_*.js):
  // при клике по кнопке чата его собственный код падает на неинициализированном
  // объекте. Код чужой, чинить нечего — только шумит.
  /crm\/site_button/i,
  /b24-widget/i,
  /openLiveChat/i,
  // Расширения браузера, парсящие schema.org / microdata со страницы
  /extractSchemaValuesFromSchemaOrg/i,
  /extractFilteredSchemaValuesFromMicroData/i,
  // Транзиентный сбой связи клиента: до браузера вообще не дошёл ответ
  // (обрыв соединения, оффлайн, уход со страницы). Это НЕ медленный бэкенд —
  // он всё равно вернул бы ответ со статусом. Таймауты сюда не входят: они
  // означают "бэкенд не ответил вовремя" и должны попадать в GlitchTip.
  // "Network Error" — axios (XHR), "Failed to fetch" — нативный fetch
  // (в т.ч. загрузка данных страницы роутером Next.js при смене фильтров).
  /Network Error/i,
  /Failed to fetch/i,
  // Безвредное предупреждение браузера, ~1.5 тыс. событий в день
  /ResizeObserver loop/i,
  // Бот Baidu (UA "pc") внедряет свой jshost, перехватывает addEventListener
  // и падает на Maximum call stack / null.text в своём же коде
  /jshost/i,
  /addEL_hook/i,
  /appendMessageToLinks/i,
  // Чужие скрипты: zp.js и встроенный браузер рекламных SDK в приложениях
  /zp_token/i,
  /notifyReadyEvent/i,
  /fireChangeEvent/i,
];

const IGNORED_URL_PATTERNS = [
  /extensions\//i,
  /^chrome:\/\//i,
  /^chrome-extension:\/\//i,
  /roistat/i,
  /myreviews/i,
  /getreview/i,
  /crm\/site_button/i,
];

// Боты, которые исполняют JS и шлют события как обычные браузеры:
// - скрейпер с поддельным UA Chrome 99 (проверяет ссылки HEAD-запросами,
//   ловит 503 на /api/client/* и /bxApi) — ~2/3 событий 503 в октябре 2026;
// - Baiduspider-render.
const IGNORED_USER_AGENT_PATTERNS = [
  /Chrome\/99\.0\.4844\.51 /,
  /Baiduspider/i,
];

function getEventUserAgent(event) {
  const headers = event.request?.headers || {};
  return (
    headers["User-Agent"] ||
    headers["user-agent"] ||
    (typeof navigator !== "undefined" ? navigator.userAgent : "") ||
    ""
  );
}

function getEventText(event) {
  const exception = event.exception?.values?.[0];
  const message = exception?.value || event.message || "";
  const frames = exception?.stacktrace?.frames || [];
  const stackText = frames
    .map((frame) => `${frame.filename || ""} ${frame.function || ""}`)
    .join("\n");

  return `${message}\n${stackText}`;
}

function shouldIgnoreEvent(event) {
  const userAgent = getEventUserAgent(event);
  if (IGNORED_USER_AGENT_PATTERNS.some((pattern) => pattern.test(userAgent))) {
    return true;
  }

  const text = getEventText(event);

  if (IGNORED_ERROR_PATTERNS.some((pattern) => pattern.test(text))) {
    return true;
  }

  const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
  if (frames.some((frame) => frame.filename?.includes("chrome-extension"))) {
    return true;
  }

  // Скрипт Calltouch на iOS Safari отклоняет промис с undefined, когда не может
  // поставить свою cookie (calltouchdns_not_available, «Calltouch global cookie
  // error»). Стека у такой ошибки нет — узнаём её по последним крошкам.
  if (/Non-Error promise rejection captured with value: undefined/.test(text)) {
    const recent = (event.breadcrumbs || []).slice(-6);
    if (
      recent.some((b) =>
        /calltouch/i.test(`${b.message || ""} ${b.data?.url || ""}`),
      )
    ) {
      return true;
    }
  }

  return false;
}

function sentryBeforeSend(event) {
  return shouldIgnoreEvent(event) ? null : event;
}

const sentryIgnoreOptions = {
  ignoreErrors: [
    "Request aborted",
    /roistat/i,
    /myreviews/i,
    /getreview/i,
    /VerticalWidget/i,
    /openLiveChat/i,
    /Network Error/i,
    /Failed to fetch/i,
  ],
  denyUrls: IGNORED_URL_PATTERNS,
  beforeSend: sentryBeforeSend,
};

module.exports = {
  sentryBeforeSend,
  sentryIgnoreOptions,
};
